import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/constants/queryKeys";
import { services } from "@/services/registry";
export function useLicensesByContract(contractId, options = {}) {
    const { enabled = true, status } = options;
    return useQuery({
        queryKey: queryKeys.licenses.byContract(contractId, status),
        queryFn: ()=>services.licensesService.getLicensesByContract(contractId, status),
        staleTime: 2 * 60 * 1000,
        enabled: enabled && !!contractId
    });
}
export function useGenerateLicense() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ contractId, licenseAnchors })=>services.licensesService.generateLicense(contractId, licenseAnchors),
        onSuccess: (_data, variables)=>{
            // Invalidate all license queries for this contract
            queryClient.invalidateQueries({
                queryKey: queryKeys.licenses.byContract(variables.contractId)
            });
        }
    });
}
export function useRegenerateLicense() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ contractId, licenseAnchors })=>services.licensesService.regenerateLicense(contractId, licenseAnchors),
        onSuccess: (_data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: queryKeys.licenses.byContract(variables.contractId)
            });
        }
    });
}
export function useDownloadLicense() {
    return useMutation({
        mutationFn: ({ licenseId, customerId })=>services.licensesService.downloadLicense(licenseId, customerId)
    });
}
/**
 * Trigger a browser download of a license PEM file.
 */ export function downloadLicenseFile(blob, licenseId) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `license-${licenseId}.pem`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
